export default "__VITE_ASSET__DCJX4O3V__"